// extracted by mini-css-extract-plugin
export default {"cardContainer":"recom_cardContainer__vvxCJ","showCard":"recom_showCard__mYYrV","editStyle":"recom_editStyle__p8aOi","font20":"recom_font20__aGwrA"};